// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2467":"4e460d7fd784b93f","4896":"84f6640a228a67d3","5259":"fc301960a33d88b1","8199":"f01407468f07465e","8232":"42607423142ae82a","9700":"d3dc3f3c1c42f3ca"}[chunkId] + ".css";
};